module.exports = __webpack_public_path__ + "static/img/11-海外装饰.64a0fede.png";